/* eslint-disable react-hooks/exhaustive-deps */
import { BookingProvider, Path } from "@common/constans";
import { IMenuItem } from "@common/models/CMS";
import Avatar from "@components/Avatar";
import Button from "@components/general/form/Button";
import Icon from "@components/general/Icon";
import { IViewport } from "@config/appConfig";
import { Culture } from "@core/index";
import { IAppState } from "@misc/State";
import { redirectToLogin, redirectToLogout } from "@service/Account";
import Config from "@service/Config";
import Translate from "@service/Translate";
import { FC, MouseEvent, useEffect, useRef, useState } from "react";
import ContentLoader from "react-content-loader";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";

interface IHeaderMenuSectionProps {
    menuItem: IMenuItem;
}
let isTransparent: boolean;
const HeaderMenuSection: FC<IHeaderMenuSectionProps> = ({ menuItem }) => {
    const { tr } = Translate;
    const { dir } = Culture.getLocale();
    const headerRef = document.getElementById('header');
    const { user, showHeaderSkeleton, width, headerStyle } = useSelector((state: IAppState) => ({
        user: state.user,
        showHeaderSkeleton: state.showHeaderSkeleton,
        width: state.windowWidth,
        headerStyle: state.headerStyle
    }));
    const { push } = useHistory();
    const { pathname, search } = useLocation();
    const { large } = Config.get<IViewport>("viewport");
    const [currentView, setCurrentView] = useState<number>(-1);
    const menuAvatar = useRef<HTMLDivElement>(null);
    const dynamicLine = useRef<HTMLDivElement>(null);
    const skeletonAvatar = (
        <div className="skeleton-avatar flex">
            <ContentLoader
                width="140"
                height="45"
                speed={1}
                backgroundColor="#fff"
                foregroundColor="#c6c6c6"
                rtl={dir === "rtl"}
            >
                <circle cx="21" cy="21" r="21" />
                <rect x="50" y="8" rx="3" ry="3" width="80" height="11" />
                <rect x="50" y="24" rx="3" ry="3" width="60" height="11" />
            </ContentLoader>
        </div >
    );
    const skeletonIcon = (
        <div className="skeleton-icon flex">
            <ContentLoader
                width="30"
                height="30"
                speed={1}
                backgroundColor="#fff"
                foregroundColor="#c6c6c6"
                rtl={dir === "rtl"}
            >
                <circle cx="15" cy="15" r="14" />
            </ContentLoader>
        </div >
    );

    const handleHeaderStyle = () => {
        const scroll = window.pageYOffset || window.scrollY;
        if (isTransparent && scroll === 0)
            headerRef?.classList.add('transparent')
        else
            headerRef?.classList.remove('transparent')
    }

    const handleOuterMenuClick = () => {
        setCurrentView(-1);
        handleHeaderStyle();
        dynamicLine.current?.style.setProperty("visibility", "hidden");
    }

    const removeClassesFromHeader = () => {
        document.documentElement.classList.remove("overflow-hidden");
        headerRef?.classList.remove("mobile");
        menuAvatar.current?.classList.remove("show");
        dynamicLine.current?.style.setProperty("visibility", "hidden");
    }

    useEffect(() => {
        setCurrentView(-1);
        removeClassesFromHeader();
        isTransparent = headerStyle.menuStyle === "Transparent" ? true : false;
    }, [pathname, headerStyle])

    const onCloseMenuBtnClick = () => {
        removeClassesFromHeader();
        setCurrentView(-1);
        handleHeaderStyle();
    }

    const renderDynamicLine = (event: MouseEvent<HTMLElement>) => {
        const currentItem = event?.currentTarget;
        if (dynamicLine && dynamicLine.current) {
            dynamicLine.current.style.width = currentItem.offsetWidth + 'px';
            dynamicLine.current.style.left = currentItem.offsetLeft + 'px';
            dynamicLine.current.style.visibility = 'visible';
        }
    }

    const onMenuItemClick = (event: MouseEvent<HTMLElement>, i: number) => {
        const target = event.target as HTMLElement;
        renderDynamicLine(event);
        if (target.id && target.id !== `megaMenuItem${i}`) {
            if (width <= large && currentView !== -1)
                setCurrentView(-1);
            else
                setCurrentView(i);
            headerRef?.classList.remove("transparent");
        }
    }

    const onBurgerMenuClick = () => {
        if (headerRef?.classList.contains('mobile'))
            onCloseMenuBtnClick()
        else {
            document.documentElement.classList.add("overflow-hidden");
            headerRef?.classList.remove("transparent");
            headerRef?.classList.add("mobile");
        }
    }

    const onAvatarItemClick = () => {
        if (user.memberId)
            if (menuAvatar.current?.classList.contains("show"))
                menuAvatar.current?.classList.remove("show")
            else
                menuAvatar.current?.classList.add("show")
        else
            redirectToLogin();
    }

    const redirectToChangePassword = () => {
        window.location.href = `${Config.get("issuer")}/manage/changepassword?clientId=${Config.get("clientId")}&redirectUrl=${Config.get("redirectUrl")}/`;
    }

    return (
        <section className="header-menu-section">
            <div className="logo-section">
                <Button id="logoBtn" url={Path.Home} className="transparent-hover" icon="icon-mahan-air-logo" />
            </div>
            <menu className="menu-section">
                {
                    Config.config.defaultBookingProvider === BookingProvider.Mahan ?
                        <div id="menuAvatar" ref={menuAvatar} className="menu-section-avatar" >
                            <div className="menu-section-avatar-item flex flex-center justify-between" onClick={onAvatarItemClick}>
                                {
                                    showHeaderSkeleton ? skeletonAvatar :
                                        user.memberId ? <Avatar />
                                            : <Button
                                                id="loginRegisterBtn"
                                                text={tr("btn_login_register")}
                                                color="white"
                                                width="auto"
                                                height="44px"
                                                className="login-register-btn-mobile transparent-hover"
                                            />
                                }
                                {showHeaderSkeleton ? skeletonIcon : <Icon name="icon-chevron-left" size="34px" />}
                            </div>
                            {
                                user.memberId ?
                                    <div className="mega-menu-section-avatar">
                                        <Button
                                            className="profile-item"
                                            color="white"
                                            icon="color icon-list1"
                                            height="45px" text={tr("profile_account_information")}
                                            onClick={() => {
                                                removeClassesFromHeader();
                                                push(Path.Profile.Home);
                                            }}
                                        />
                                        <Button
                                            className="profile-item"
                                            color="white"
                                            icon="color icon-passenger-info"
                                            height="45px"
                                            text={tr("my_trips")}
                                            onClick={() => {
                                                removeClassesFromHeader();
                                                push(Path.Profile.History);
                                            }}
                                        />
                                        <div className="flex flex-center justify-end mega-menu-log-out-section">
                                            <Button
                                                className="profile-item"
                                                color="white"
                                                icon="color icon-lock"
                                                width="auto"
                                                height="40px"
                                                text={tr("change_password")}
                                                onClick={() => {
                                                    removeClassesFromHeader();
                                                    redirectToChangePassword();
                                                }}
                                            />
                                            <Button
                                                className="profile-item"
                                                color="white"
                                                icon="color icon-sign-out"
                                                width="auto"
                                                height="40px"
                                                text={tr("btn_logout")}
                                                onClick={() => {
                                                    onAvatarItemClick();
                                                    redirectToLogout();
                                                }} />
                                        </div>
                                    </div>
                                    : ""
                            }

                        </div> : ''
                }
                <ul className="menu-section-nav">
                    {
                        menuItem.menuItemsList?.menuItems.map((item, i) =>
                            item.hiddenLink ? '' :
                                <li
                                    key={i}
                                    id={`menuItem${i}`}
                                    className={`menu-item${currentView === -1 && item.menuItemsList?.menuItems.find(i => pathname === i.linkMenuItem?.url) ? " active" : ""}${currentView === i ? " show-menu-item" : currentView !== -1 && width <= large ? " hide" : ""}`}
                                    onClick={(event) => !item.externalLink && onMenuItemClick(event, i)}
                                >
                                    {
                                        item.linkMenuItem?.url ?
                                            item.externalLink ?
                                                <a tabIndex={i} id={`linkMenuItem${i}`} href={item.linkMenuItem?.url} target="_blank" rel="noreferrer">
                                                    <span>{item.displayText}</span>
                                                </a>
                                                :
                                                <Link to={item.linkMenuItem?.url}>{item.displayText}</Link>
                                            :
                                            <Link to={`${pathname}${search}`} role="button" tabIndex={i} id={`linkMenuItem${i}`}>{item.displayText}</Link>
                                    }
                                    <div className="mega-menu-container">
                                        <div className="container">
                                            <ul className="row flex mega-menu">
                                                {item.menuItemsList?.menuItems.map((i, index) =>
                                                    i.hiddenLink ? '' :
                                                        <li
                                                            key={index}
                                                            className={`col-1-4 col-md-1-1 col-sm-1-1 flex flex-center mega-menu-item${pathname === i.linkMenuItem?.url ? " active" : ""}`}
                                                        >
                                                            {
                                                                i.externalLink ?
                                                                    <a href={i.linkMenuItem?.url} target="_blank" rel="noreferrer">
                                                                        <span>{i.displayText}</span>
                                                                    </a>
                                                                    :
                                                                    <Link
                                                                        id={`megaMenuItem${i}`} to={i.linkMenuItem?.url || ""}
                                                                        onClick={() => { removeClassesFromHeader(); handleOuterMenuClick() }}
                                                                    >
                                                                        {i.displayText}
                                                                    </Link>
                                                            }
                                                        </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                    <Icon
                                        id={`iconMenuItem${i}`}
                                        name="icon-chevron-left"
                                        className="menu-item-icon-forward"
                                    />
                                </li>
                        )
                    }
                    <div className="dynamic-Line" ref={dynamicLine}></div>
                </ul>
            </menu>
            <div className={`background${currentView !== -1 ? " show" : ""}`} onClick={handleOuterMenuClick} />
            <div
                className="menu-burger-btn flex flex-center justify-center"
                onClick={onBurgerMenuClick}
            >
                <div className="linear" />
                <div className="linear" />
                <div className="linear" />
            </div>
        </section>
    )
}

export default HeaderMenuSection;